import interceptedAxios from '../../../utils/interceptedAxios'
import LanguageStrings from '../../../i18n/locales'
const AddDeviceComponent = LanguageStrings().DeviceManagementCollectionStrings.AddDeviceComponent

export async function toggleEmailGroupEnabled (
  groupId: string,
  enabled: boolean,
  onSuccess: (data: any, httpStatus: number) => void,
  onFailure: (errorMessage: any, httpStatus: number) => void
): Promise<void> {
  const url = `/communications-service/api/v1/udp/tiq/services/email/${groupId}/toggle-status?enabled=${enabled ? 'true' : 'false'}`
  interceptedAxios
    .put(url, {}, { timeout: 15000 })
    .then((response) => {
      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.http_status === 200 &&
        response.data.data !== undefined &&
        response.data.data !== null
      ) {
        onSuccess(response.data.data, response.data.http_status)
      } else {
        onFailure(response.data?.error, response.data?.http_status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.data.http_status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure(AddDeviceComponent.NetworkError, error.status)
      }
    })
}
